/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AfregningDto as OkEgisServiceModelsDtoAfregningDto } from '../models/OK/Egis/Service/Models/DTO/afregning-dto';
import { OpkraevningsLinieDto as OkEgisServiceModelsDtoOpkraevningsLinieDto } from '../models/OK/Egis/Service/Models/DTO/opkraevnings-linie-dto';

@Injectable({
  providedIn: 'root',
})
export class AfregningService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getAfregningerForServiceaftale
   */
  static readonly GetAfregningerForServiceaftalePath = '/api/v1/Afregning/GetAfregningerForServiceaftale';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAfregningerForServiceaftale()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAfregningerForServiceaftale$Response(params: {
    serviceaftaleId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoAfregningDto>>> {

    const rb = new RequestBuilder(this.rootUrl, AfregningService.GetAfregningerForServiceaftalePath, 'get');
    if (params) {
      rb.query('serviceaftaleId', params.serviceaftaleId, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoAfregningDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAfregningerForServiceaftale$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAfregningerForServiceaftale(params: {
    serviceaftaleId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoAfregningDto>> {

    return this.getAfregningerForServiceaftale$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoAfregningDto>>) => r.body as Array<OkEgisServiceModelsDtoAfregningDto>)
    );
  }

  /**
   * Path part for operation getCustomerOpkraevningerForCurrentServiceinterval
   */
  static readonly GetCustomerOpkraevningerForCurrentServiceintervalPath = '/api/v1/Afregning/GetCustomerOpkraevningerForCurrentServiceinterval';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomerOpkraevningerForCurrentServiceinterval()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerOpkraevningerForCurrentServiceinterval$Response(params: {
    serviceaftaleId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoAfregningDto>>> {

    const rb = new RequestBuilder(this.rootUrl, AfregningService.GetCustomerOpkraevningerForCurrentServiceintervalPath, 'get');
    if (params) {
      rb.query('serviceaftaleId', params.serviceaftaleId, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoAfregningDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCustomerOpkraevningerForCurrentServiceinterval$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerOpkraevningerForCurrentServiceinterval(params: {
    serviceaftaleId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoAfregningDto>> {

    return this.getCustomerOpkraevningerForCurrentServiceinterval$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoAfregningDto>>) => r.body as Array<OkEgisServiceModelsDtoAfregningDto>)
    );
  }

  /**
   * Path part for operation getOpkraevningsLinerForOpkraevning
   */
  static readonly GetOpkraevningsLinerForOpkraevningPath = '/api/v1/Afregning/GetOpkraevningsLinerForOpkraevning';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOpkraevningsLinerForOpkraevning()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOpkraevningsLinerForOpkraevning$Response(params: {
    id?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoOpkraevningsLinieDto>>> {

    const rb = new RequestBuilder(this.rootUrl, AfregningService.GetOpkraevningsLinerForOpkraevningPath, 'get');
    if (params) {
      rb.query('id', params.id, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoOpkraevningsLinieDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getOpkraevningsLinerForOpkraevning$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOpkraevningsLinerForOpkraevning(params: {
    id?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoOpkraevningsLinieDto>> {

    return this.getOpkraevningsLinerForOpkraevning$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoOpkraevningsLinieDto>>) => r.body as Array<OkEgisServiceModelsDtoOpkraevningsLinieDto>)
    );
  }

}
